import { z } from "zod";
import { ParsePayload } from "zod/v4/core";

import { CONTROL_TAGS_PREFIX } from "./constants";
import { TagColumn } from "./types";

/**
 * Tag parsing and validation module.
 * Extracts and validates tag data from spreadsheet rows.
 */

/**
 * Schema for validating and transforming tag columns into structured TagColumn objects
 */
export const TagFieldsSchema = z
    .object({})
    .catchall(z.string())
    .transform(processTagFields);

/**
 * Processes tag field data from spreadsheet columns into TagColumn objects
 */
export function processTagFields(
    data: Record<string, string>,
    ctx: ParsePayload
): TagColumn[] {
    return Object.entries(data)
        .filter(([key]) => key.startsWith(CONTROL_TAGS_PREFIX))
        .flatMap(([key, value]): TagColumn[] => {
            const categoryName = key.slice(CONTROL_TAGS_PREFIX.length).trim();

            if (categoryName.length === 0) {
                ctx.issues.push({
                    code: "custom",
                    message: `Invalid tag category name in column: ${key}`,
                    input: ctx.value,
                });
                return [];
            }

            const trimmedValue = value.trim();
            if (trimmedValue === "") {
                return [{ category: categoryName, tags: [] }];
            }

            const tags = trimmedValue
                .split(";")
                .map((tag) => tag.trim())
                .filter(Boolean);

            return [{ category: categoryName, tags }];
        });
}
